export default __webpack_public_path__ + "static/media/IMG_0059.db5cb176.mp4";